import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PulseemResponse } from '../../Models/APIResponse';
import { PulseemReactInstance } from '../../helpers/Api/PulseemReactAPI';

// SSO (SAML) self-setup for the account Admin.
// WebSiteAPI: Controllers/Settings/SsoSettingsController.cs (api/SsoSettings/...)

const post = (name: string, url: string) => createAsyncThunk(
    `SsoSettings/${name}`, async (body: any, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.post(url, body);
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    });

export const getSsoSettings = createAsyncThunk(
    'SsoSettings/Get', async (_, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.get('SsoSettings');
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    });

export const startSsoSetup = post('Start', 'SsoSettings/Start');
export const saveSsoMetadataLink = post('MetadataLink', 'SsoSettings/MetadataLink');   // { Url }
export const saveSsoMetadataFile = post('MetadataFile', 'SsoSettings/MetadataFile');   // { Xml }
export const saveSsoUsers = post('Users', 'SsoSettings/Users');                        // { Users: [{ UserName, SsoNameId }] }
export const saveSsoMode = post('Mode', 'SsoSettings/Mode');                           // { Mode: 0 | 1 | 2 }
export const saveSsoShare = post('Share', 'SsoSettings/Share');                        // { Share: true | false } - main account -> sub-accounts

const SsoSettingsSlice = createSlice({
    name: 'SsoSettings',
    initialState: {},
    reducers: {},
    extraReducers: () => {},
})

export default SsoSettingsSlice.reducer;
